import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const ButtonsContainerStyle = styled.div`
  ${({ padding = '0.5rem' }) => css`
    padding: ${padding};
  `}
  ${({ alignCenter }) =>
    alignCenter &&
    css`
      text-align: center;
    `}
`;

export const RectangleButtonStyle = styled.button`
  color: ${({ theme }) => theme.button.label};
  background: ${({ theme }) => theme.button.background};
  border: 1px solid ${({ theme }) => theme.button.border};
  border-radius: 0.25rem;
  margin: 0;
  padding: 0.375rem 1rem;
  &:hover {
    background: ${({ theme }) => theme.button.backgroundHover};
    border: 1px solid ${({ theme }) => theme.button.borderHover};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
  &:disabled {
    background: ${({ theme }) => theme.button.backgroundDisabled};
    border: 1px solid ${({ theme }) => theme.button.borderDisabled};
  }

  ${({ small }) =>
    small &&
    css`
      font-size: 0.875rem;
      padding: 0.25rem 0.75rem;
    `}
  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: 0.5rem;
    `}
  ${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: 0.5rem;
    `}
  ${({ floatRight }) =>
    floatRight &&
    css`
      float: right;
    `}
`;

export const RectangleDropdownButtonLeft = styled(RectangleButtonStyle)`
  border-radius: 0.25rem 0rem 0 0.25rem;
  padding: 4px 4px 4px 8px;
`;

export const RectangleDropdownButtonRight = styled(RectangleButtonStyle)`
  border-radius: 0rem 0.25rem 0.25rem 0;
  padding: 4px 8px;
`;

export const RectangleButtonLinkStyle = styled.a`
  appearance: button;
  color: ${({ theme }) => theme.button.label};
  background: ${({ theme }) => theme.button.background};
  border: 1px solid ${({ theme }) => theme.button.border};
  border-radius: 0.25rem;
  margin: 0;
  padding: 0.375rem 1rem;
  &:hover {
    background: ${({ theme }) => theme.button.backgroundHover};
    border: 1px solid ${({ theme }) => theme.button.borderHover};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
  &:disabled {
    background: ${({ theme }) => theme.button.backgroundDisabled};
    border: 1px solid ${({ theme }) => theme.button.borderDisabled};
  }

  ${({ small }) =>
    small &&
    css`
      font-size: 0.875rem;
      padding: 0.25rem 0.75rem;
    `}
  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: 0.5rem;
    `}
${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: 0.5rem;
    `}
${({ floatRight }) =>
    floatRight &&
    css`
      float: right;
    `}
`;

export const TwitterButtonStyle = styled.div`
  color: ${colors.white};
  background: ${colors.fsDarkBlue};
  padding: 6px 18px;
  border-radius: 25px;
  border: 2px solid transparent;
  transition: padding 0.25s ease-in-out;
  cursor: pointer;

  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;

  > i {
    margin-right: 5px;
  }

  :hover {
    color: ${colors.fsCyan};
    background: ${colors.white};
    text-decoration: none;
    border: 2px solid ${colors.fsCyan};
  }
`;

export const SmallButtonStyle = styled.button`
  color: ${colors.white};
  background: ${colors.fsDarkBlue};
  border: 2px solid ${colors.fsDarkBlue};
  border-radius: 25px;
  color: ${colors.white};
  font-size: 9px;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 1px;
  transition: padding 0.25s ease-in-out;
  user-select: none;
  appearance: none !important;
  white-space: nowrap;
  padding: 5px 5px;

  &:hover {
    background: ${colors.white};
    color: ${colors.fsCyan};
    border: 2px solid ${colors.fsCyan};
    text-decoration: none;
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }
  ${({ primaryRed }) =>
    primaryRed &&
    css`
      background: ${colors.red};
      border: 2px solid ${colors.red};

      :hover {
        border: 2px solid ${colors.red};
        color: ${colors.red};
      }
    `}
`;

export const SmallButtonLinkStyle = styled.a`
  color: ${colors.white};
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;

  :hover {
    color: ${colors.fsCyan};
    text-decoration: none;
  }
`;

export const ButtonIcon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  margin-right: 5px;
`;

export const ContainerIconButton = styled.button`
  border: 0;
  line-height: 0;
  height: 2rem;
  width: 2rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.button.background};
  color: ${({ theme }) => theme.button.label};
  &:hover {
    color: ${({ theme }) => theme.button.label};
    background: ${({ theme }) => theme.button.backgroundHover};
  }
  &:disabled {
    background: ${({ theme }) => theme.button.backgroundDisabled};
  }
`;

export const ContainerIconButtonLink = styled.a`
  line-height: 2;
  text-align: center;
  height: 2rem;
  width: 2rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.button.background};
  color: ${({ theme }) => theme.button.label};
  &:hover {
    color: ${({ theme }) => theme.button.label};
    background: ${({ theme }) => theme.button.backgroundHover};
  }
`;

export const IconButtonIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  font-size: 1rem;
  ${({ spinner }) =>
    spinner &&
    css`
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      animation: spin 1s infinite linear;
    `}
`;

export const RectangleDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const RectangleDropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border-top: none;
  display: block;
  background: ${({ theme }) => theme.dropdown.background};
  border: 1px solid ${({ theme }) => theme.dropdown.border};
  border-radius: 5px;
  box-shadow: 0px 6px 12px -3px ${colors.black};
`;

export const RectangleDropdownOptionLabel = styled.label`
  display: block;
  padding: 5px;
  cursor: pointer;
  margin-bottom: 0;
  color: ${({ theme }) => theme.dropdown.label};
  :hover {
    background: ${({ theme }) => theme.dropdown.backgroundHover};
  }
  input {
    margin-right: 8px;
  }
`;

export const ITag = styled.i.attrs(({ icon }) => ({ className: icon }))`
  transition: transform 0.35s ease-in-out;
  ${({ isRadioIcon }) =>
    isRadioIcon &&
    css`
      margin-right: 7px;
    `}
`;

export const RectangleDropdownExpandIcon = styled.i.attrs(() => ({
  className: 'fa fa-caret-down',
}))`
  transition: transform 0.35s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;
